import React, { Fragment, useState } from 'react';
import { Icon } from 'selfly-ui-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { handleGroupChange } from '../../actions/user';

import i18n from '../../i18n';
import { keycloakRef } from '../auth/KeycloakProvider';

const MobileNavigation = props => {
    const { user, handleGroupChange, t } = props;
    const [openMenuContent, setOpenMenuContent] = useState(false);
    const [openOrganisationContent, setOpenOrganisationContent] = useState(false);
    const [openLanguageContent, setOpenLanguageContent] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
    const [selectedOrganisation, setSelectedOrganisation] = useState(user.group);
    const [filteredGroups, setFilteredGroups] = useState(user.profile.groups || []);

    const isAdmin = user && user.isAdmin;
    const isRefillOperator = user && user.isRefillOperator;

    const redirectPage = destination => {
        const { history } = props;
        setOpenLanguageContent(false);
        setOpenOrganisationContent(false);
        setOpenMenuContent(false);
        history.push(`/${destination}`);
    };

    const allLanguages = JSON.parse(process.env.REACT_APP_LANGUAGES);

    const filterGroup = event => {
        const inputValue = event.target.value.toLowerCase();
        let filtered = user.profile.groups;
        if (inputValue !== '') {
            filtered = filtered.filter(g => g.Name.toLowerCase().includes(inputValue));
        }
        setFilteredGroups(filtered);
    };

    const getLanguageContents = () => {
        return (
            <div className="nav-mb__items">
                <ul className="nav-mb__content-menu">
                    {allLanguages.map(language => {
                        return (
                            <li
                                onClick={() => {
                                    i18n.changeLanguage(language);
                                    setSelectedLanguage(language);
                                    closeMenuPage();
                                }}
                                key={language}
                                className={`${selectedLanguage === language ? 'nav-mb__content-menu--active' : ''}`}
                            >
                                <span> {i18n.getNativeName(language)} </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    const getOrganisationContent = () => {
        const allgroups = user.profile.groups;

        if (allgroups.length === 0) return;

        const changeGroup = group => {
            handleGroupChange({ Id: group.Id, Name: group.Name });
            setSelectedOrganisation(group);
            closeMenuPage();
        };

        return (
            <div className="nav-mb__items">
                <div className="scp-header__menu-search">
                    <input type="text" placeholder={t('header:searchByOrganization')} onChange={e => filterGroup(e)} />
                    <svg>
                        <use xlinkHref="#icon-search"></use>
                    </svg>
                </div>
                <ul className="nav-mb__content-menu">
                    {filteredGroups.map((group, index) => {
                        return (
                            <li
                                key={`${group.Id}-${index}`}
                                onClick={() => {
                                    changeGroup(group);
                                }}
                                className={`${group.Name === selectedOrganisation.Name ? 'nav-mb__content-menu--active' : ''}`}
                            >
                                <span>{group.Name}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    const closeMenuPage = () => {
        setOpenLanguageContent(false);
        setOpenOrganisationContent(false);
        setOpenMenuContent(false);
        setFilteredGroups(user.profile.groups || []);
    };

    const getMenuContents = () => {
        return (
            <div className="nav-mb__items">
                <ul className="nav-mb__content-menu">
                    <li onClick={() => redirectPage('analytics')}>
                        <svg>
                            <use xlinkHref="#icon-stats-dots"></use>
                        </svg>
                        <span>{t('analytics')}</span>
                    </li>
                    {isAdmin && (
                        <Fragment>
                            <li onClick={() => redirectPage('devices')}>
                                <svg>
                                    <use xlinkHref="#icon-cog"></use>
                                </svg>
                                <span>{t('deviceManagement')}</span>
                            </li>
                            <li onClick={() => redirectPage('advertisements')}>
                                <svg>
                                    <use xlinkHref="#icon-images"></use>
                                </svg>
                                <span>{t('advertisements')}</span>
                            </li>
                        </Fragment>
                    )}
                    <li onClick={() => redirectPage('products')}>
                        <svg>
                            <use xlinkHref="#icon-cube"></use>
                        </svg>
                        <span>{t('productCatalog')}</span>
                    </li>
                    {isAdmin && (
                        <li onClick={() => redirectPage('discounts')}>
                            <svg>
                                <use xlinkHref="#icon-discout"></use>
                            </svg>
                            <span>{t('discounts')}</span>
                        </li>
                    )}
                    {(isAdmin || isRefillOperator) && (
                        <li onClick={() => redirectPage('refill-plans')}>
                            <svg>
                                <use xlinkHref="#icon-workspaces_filled"></use>
                            </svg>
                            <span>{t('refillManagement')}</span>
                        </li>
                    )}
                </ul>
                {isAdmin && (
                    <ul className="nav-mb__content-menu">
                        <li onClick={() => redirectPage('settings-consumer-app')}>
                            <svg>
                                <use xlinkHref="#icon-phone"></use>
                            </svg>
                            <span>{t('mySelfly')}</span>
                        </li>
                        <li onClick={() => redirectPage('software-versions')}>
                            <svg>
                                <use xlinkHref="#icon-refresh1"></use>
                            </svg>
                            <span>{t('softwareVersions:softwareVersions')}</span>
                        </li>
                        <li onClick={() => redirectPage('automations')}>
                            <svg>
                                <use xlinkHref="#automations"></use>
                            </svg>
                            <span>{t('automations')}</span>
                        </li>
                        <li onClick={() => redirectPage('consumers')}>
                            <svg>
                                <use xlinkHref="#icon-users"></use>
                            </svg>
                            <span>{t('consumers:consumers')}</span>
                        </li>
                    </ul>
                )}
                <ul className="nav-mb__content-menu">
                    <li
                        className="nav-mb__content-menu nav-mb__content-menu-navigate"
                        onClick={() => {
                            if (user.profile.groups.length === 1) return;
                            setOpenOrganisationContent(true);
                        }}
                    >
                        <span>
                            <svg>
                                <use xlinkHref="#icon-office"></use>
                            </svg>
                            {user && user.group && user.group.Name}
                        </span>
                        <span>
                            <svg>
                                <use xlinkHref="#icon-arrow-right"></use>
                            </svg>
                        </span>
                    </li>
                    <li className="nav-mb__content-menu nav-mb__content-menu-navigate" onClick={() => setOpenLanguageContent(true)}>
                        <span>
                            <svg>
                                <use xlinkHref="#icon-world"></use>
                            </svg>
                            {i18n.getNativeName(selectedLanguage)}
                        </span>
                        <span>
                            <svg>
                                <use xlinkHref="#icon-arrow-right"></use>
                            </svg>
                        </span>
                    </li>
                </ul>
                <ul className="nav-mb__content-menu">
                    <li
                        className="nav-mb__content-menu nav-mb__content-menu-navigate"
                        onClick={() => window.open('https://community.selflystore.com', '_blank', 'noopener')}
                    >
                        <span>
                            <svg>
                                <use xlinkHref="#icon-users"></use>
                            </svg>
                            {t('community')}
                        </span>
                        <span className="nav-mb__content-menu-blank">
                            <i className="ml-1 fas fa-external-link-alt"></i>
                        </span>
                    </li>

                    <li
                        className="nav-mb__content-menu nav-mb__content-menu-navigate"
                        onClick={() => window.open('https://www.selflystore.com/privacy', '_blank', 'noopener')}
                    >
                        <span>
                            <svg>
                                <use xlinkHref="#icon-privacy_tip"></use>
                            </svg>
                            {t('main:privacyPolicy')}
                        </span>
                        <span className="nav-mb__content-menu-blank">
                            <i className="ml-1 fas fa-external-link-alt"></i>
                        </span>
                    </li>
                    <li
                        className="nav-mb__content-menu nav-mb__content-menu-navigate"
                        onClick={() => window.open('https://www.selflystore.com/legal-notice', '_blank', 'noopener')}
                    >
                        <span>
                            <svg>
                                <use xlinkHref="#icon-gavel"></use>
                            </svg>
                            {t('main:legalNotice')}
                        </span>
                        <span className="nav-mb__content-menu-blank">
                            <i className="ml-1 fas fa-external-link-alt"></i>
                        </span>
                    </li>
                </ul>
            </div>
        );
    };

    return (
        <Fragment>
            <div className="nav-mb">
                <div>
                    <div className="nav-mb__menu" onClick={() => setOpenMenuContent(true)}>
                        <Icon>menu</Icon>
                    </div>
                </div>
                <a href="/">
                    <img
                        className="scp-header__trademark-logo"
                        src="https://cdn.selflystore.com/images-general/logos/selfly-logo.svg"
                        alt="selfly-store-logo"
                    />
                </a>
            </div>
            <div className={`nav-mb__content ${openMenuContent ? 'nav-mb__content--open' : ''}`}>
                <div className="nav-mb__content-header">
                    <div className="nav-mb__menu" onClick={() => closeMenuPage()}>
                        <Icon>close</Icon>
                    </div>
                </div>
                {openLanguageContent && getLanguageContents()}

                {openOrganisationContent && getOrganisationContent()}

                {!openLanguageContent && !openOrganisationContent && getMenuContents()}
                <div className="nav-mb__signout" onClick={() => keycloakRef.current.logout()}>
                    <svg>
                        <use xlinkHref="#icon-log-out"></use>
                    </svg>
                    <span>Logout</span>
                </div>
            </div>
        </Fragment>
    );
};
export default withRouter(
    connect(
        state => ({
            user: state.user,
        }),
        { handleGroupChange }
    )(translate('navigation')(MobileNavigation))
);
